/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemOrigin = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_100: 100
} as const;
export type MailboxItemOrigin = typeof MailboxItemOrigin[keyof typeof MailboxItemOrigin];


export function instanceOfMailboxItemOrigin(value: any): boolean {
    for (const key in MailboxItemOrigin) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemOrigin, key)) {
            if (MailboxItemOrigin[key as keyof typeof MailboxItemOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemOriginFromJSON(json: any): MailboxItemOrigin {
    return MailboxItemOriginFromJSONTyped(json, false);
}

export function MailboxItemOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemOrigin {
    return json as MailboxItemOrigin;
}

export function MailboxItemOriginToJSON(value?: MailboxItemOrigin | null): any {
    return value as any;
}

export function MailboxItemOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemOrigin {
    return value as MailboxItemOrigin;
}

